import { DefaultState } from 'store/types';

export const SET_REQUEST_TABLE_COLUMNS = 'SET_REQUEST_TABLE_COLUMNS';

export type RequestTableColumnsState = DefaultState & {
  contents: string[];
};

interface SetRequestTableColumns {
  type: typeof SET_REQUEST_TABLE_COLUMNS;
  contents: string[];
}

export type RequestTableColumnsActionTypes = SetRequestTableColumns;
